import decorativo from '../../../Assets/img/shape13.svg'
import { imagesCompanias } from '../../../Assets/imageCompania'
import { Hero } from '../Components/Hero'
import { PreguntasFrecuentes } from '../Components/PreguntasFrecuentes'
import { PasosCotizar } from '../Components/PasosCotizar'
import { CompaniasSlider } from '../Components/CompaniasSlider'
import useSEOConfig from "../../../hooks/seo/useSEOConfig"
import { Navbar } from "../Components/Navbar"
import { useConfig } from '../../../context/ConfigContext'
import { PaisType } from '../diccionario'
import { useLocation } from 'react-router-dom'
import { buscarTextoSeo } from '../../../utils/buscarTextoSeo'

const coberturas: { pais: PaisType[], value: string }[] = [
    {
        value: "Cobertura SOA",
        pais: ["UY"]
    },
    {
        value: "Responsabilidad Civil",
        pais: ["AR", "UY"]
    },
    {
        value: "Terceros Completo",
        pais: ["AR"]
    },
    {
        value: "Terceros Completo Premium",
        pais: ["AR"]
    },
    {
        value: "Todo Riesgo",
        pais: ["AR"]
    },
    {
        value: "Triple",
        pais: ["UY"]
    },
    {
        value: "Totales",
        pais: ["UY"]
    },

]

const preguntasFrecuentes: { titulo: string, subTitulo: string, pais: PaisType[] }[] = [
    {
        titulo: '¿Es obligatorio tener un seguro de auto?',
        subTitulo: 'Sí, es obligatorio contar con al menos un seguro de responsabilidad civil para poder circular legalmente.',
        pais: ["AR"]
    },
    {
        titulo: '¿Es obligatorio tener un seguro de auto?',
        subTitulo: 'Sí, es obligatorio contar con al menos un seguro de cobertura SOA para poder circular legalmente.',
        pais: ["UY"]
    },
    {
        titulo: '¿Qué diferencia hay entre un seguro a terceros y un todo riesgo?',
        subTitulo: 'El seguro a terceros cubre únicamente los daños que puedas causar a otros, mientras que el seguro de todo riesgo es más completo y también puede proteger contra daños propios al vehículo.',
        pais: ["AR", "UY"]
    },
    {
        titulo: '¿Cómo elegir el mejor seguro de auto para mí?',
        subTitulo: 'Evaluá tus necesidades, el valor de tu vehículo y tu presupuesto. Un asesor de Segurarse puede ayudarte a encontrar la opción más adecuada para vos, no dudes en consultar con nuestro equipo, ¡estamos a disposición!',
        pais: ["AR", "UY"]
    },
    {
        titulo: '¿Cómo denuncio un siniestro si soy cliente de Segurarse? ',
        subTitulo: 'Si tuviste un siniestro, ingresá a nuestra App MiSegurarse y seguí los pasos para informar debidamente el hecho. Si aún no la tenés, descargala haciendo clic en el botón “Mi Segurarse” del menú y luego en el botón de Google Play/App Store según tu sistema operativo.',
        pais: ["AR"]
    },
];

const subtitulos: { texto: string, pais: PaisType }[] = [
    {
        texto: "Sabemos lo importante que es tu auto para vos, cotizá y emití 100% online el seguro que necesitás. Sólo te pedimos unos datos y te mostramos en pocos segundos múltiples coberturas a los mejores precios del mercado.<br /><br />¿Empezamos?",
        pais: "AR"
    },
    {
        texto: "Sabemos lo importante que es tu auto para vos, cotizá 100% online y encontrá el seguro que necesitás. Sólo te pedimos unos datos y te mostramos en pocos segundos múltiples coberturas a los mejores precios del mercado.<br /><br />¿Empezamos?",
        pais: "UY"
    }
]
export const Auto = () => {

    const { config } = useConfig();
    const location = useLocation();
    const textoSeo = buscarTextoSeo(location.pathname, config.pais);

    useSEOConfig(
        {
            title: textoSeo?.title ?? "Seguros Personales y Profesionales - Asegurá tu tranquilidad",
            description: textoSeo?.description ?? "Conocé la amplia variedad de seguros que tenemos para vos · Auto · Accidentes Personales · Moto · Hogar · Asistencia al viajero · Mala Praxis · Vida · Celular",
            tituloCompleto: !!textoSeo,
            keywords: "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro Mala praxis, Seguro online, Asistencia al viajero, Aseguradoras, Seguros rivadavia, Seguro flota, Cotizar seguro",
            ogTitle:
                config.pais === "UY" ?
                    "Segurarse - Corredor de Seguros digital"
                    : "Segurarse - Bróker Integral de Seguros digitales",
            ogDescription: "Contratá el seguro que necesitás en pocos pasos. Seguros personales a tu medida al mejor precio. Te asesoramos en todo momento ¡Invertí en tu tranquilidad!",
            twitterCard: "summary_large_image"
        }
    )

    return (
        <>
            <Navbar rubro="auto" />
            <div style={{ backgroundColor: "white" }}>
                <Hero
                    titulo='Seguro de Auto'
                    subTitulo={{ __html: subtitulos.find(subtitulo => subtitulo.pais === config.pais)?.texto || "" }}
                    url='/cotizador-de-seguros-auto'
                    icon='#icon-seg-auto'
                />
                <div className="pt-70 pt-lg-80 pb-40 bg-primary position-relative">
                    <img
                        className="d-none d-lg-block pos16 blend-multipy"
                        src={decorativo}
                        alt="Decorative Shape"
                    />
                    <div className="container">
                        <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-white text-center mb-16 mb-lg-25">
                            {config.pais === "UY" ? "¿Qué cubre?": "¿Qué coberturas ofrecemos?"}
                        </h2>
                        <div className="col-10 col-lg-12 mx-auto">
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                Un seguro de auto ofrece diferentes tipos de protección para que manejes con tranquilidad. La cobertura más básica, es la de responsabilidad civil, obligatoria por ley y se encarga de cubrir los daños materiales o lesiones que puedas causar a otras personas en un accidente de tránsito.
                                <br /><br />
                                Además, existen coberturas más completas que protegen tu propio vehículo. Algunas pólizas incluyen reparaciones en caso de choque, vuelco, incendio, y hasta daños ocasionados por eventos naturales como granizo o inundaciones. También podés optar por una cobertura que incluya robo y hurto, que te protege tanto en casos de robo total del auto como en robos parciales, como el de autopartes o accesorios.
                                <br /><br />
                                Muchos seguros de auto también incluyen servicios de asistencia en ruta, que pueden ser de gran ayuda en situaciones inesperadas. Este tipo de cobertura puede ofrecer servicios como remolque, cambio de neumáticos, recarga de batería, envío de combustible, y asistencia mecánica de urgencia.
                            </p>
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                ¡Elegí la cobertura para vos!
                            </p>
                        </div>
                        <div className="px-20 px-lg-0 maxw-lg-920p mx-auto">
                            <div className="row gx-lg-80">
                                <div className="col">
                                    <ul className="list-unstyled list-bullet-md fs-16 lh-14 mb-0 text-white">
                                        {
                                            coberturas.filter(cob => cob.pais.includes(config.pais)).map((cob, index) => (
                                                <li
                                                    key={cob.value}
                                                    className={`bullet-check-primary ps-35 ps-lg-45 border-bottom 
                                                    border-2 border-white border-opacity-25 
                                                    ${coberturas.filter(cob => cob.pais.includes(config.pais)).length == (index + 1) ?
                                                            "border-lg-none" : ""
                                                        }`}>
                                                    {cob.value}
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {
                            (config.pais !== "AR" && config.pais !== "UY") &&
                            <p className="fs-17 fw-medium text-center mb-0 mt-4 text-white">
                                Si tenés dudas, contas con nuestro equipo de especialistas para asesorarte en todo momento.
                                <span><br /></span>
                                <a href="https://api.whatsapp.com/send/?phone=59892281806&text&type=phone_number&app_absent=0" target="_blank" rel="noreferrer" className="d-inline-flex align-items-center fs-17 text-black">
                                    <span className='text-white'>Chatéanos</span>
                                    <svg className="svg-icon ms-2 w-12em">
                                        <use xlinkHref="#whatsapp"></use>
                                    </svg>
                                </a>
                            </p>
                        }
                    </div>
                </div>
                {config.pais === "AR" && <PasosCotizar />}
                <div className="py-5">
                    <div className="container">
                        <div className="col-11 col-md-8 mx-auto mb-4 mb-lg-5">
                            <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-black text-center">
                                Somos un {config.pais === "UY" ? "corredor" : "bróker"}, trabajamos con las mejores aseguradoras del país
                            </h2>
                        </div>
                        <CompaniasSlider companias={imagesCompanias.filter(comp => comp.pais?.includes(config.pais))} />
                    </div>
                </div>
                <PreguntasFrecuentes
                    faqs={preguntasFrecuentes.filter(faq => faq.pais.includes(config.pais))}
                />
            </div>
        </>
    )
}
